import * as React from 'react';
import * as styles from './styles.css';
import { Responsive } from '@cian/ui-kit/responsive';

import { Text } from '../../Text';
import { ButtonGroup, Button } from '../../ButtonGroup';
import { ILegend } from '../../../types/redux';
import { Legend } from '../Legend';

import { trackRegionClick } from '../tracking';

export interface ITabContentProps {
  title: string;
  legend: ILegend[];
  graph: React.ReactNode;
  toggleGraphRegion(region: number): void;
}

export function TabContent({ title, graph, legend, toggleGraphRegion }: ITabContentProps) {
  return (
    <div className={styles['content']}>
      <div className={styles['top']}>
        <Responsive desktop>
          <div>
            <div className={styles['title']}>
              <Text size="h4" color="black" bold>
                {title}
              </Text>
            </div>
            <Legend legend={legend} />
          </div>
        </Responsive>
        <div>
          <ButtonGroup
            onChange={(regionIndex: number) => {
              trackRegionClick(regionIndex);
              toggleGraphRegion(regionIndex);
            }}
          >
            <Button>Москва</Button>
            <Button>Санкт-Петербург</Button>
          </ButtonGroup>
        </div>
      </div>
      {graph}
      <Responsive tablet phone>
        <Legend legend={legend} />
      </Responsive>
    </div>
  );
}
